import React from 'react';
import { Route } from 'react-router-dom';
import HostelSetting from '@/pages/hostel/HostelSetting';
import RoomType from '@/pages/hostel/RoomType';
import RoomSetting from '@/pages/hostel/RoomSetting';
import WardenSetting from '@/pages/hostel/WardenSetting';
import AddStudent from '@/pages/hostel/AddStudent';
import FeeSetting from '@/pages/hostel/FeeSetting';
import FeePayment from '@/pages/hostel/FeePayment';
import HostelStudentLedger from '@/pages/hostel/StudentLedger';
import FeeReport from '@/pages/hostel/FeeReport';
import HostelDamage from '@/pages/hostel/HostelDamage';
import HostelFine from '@/pages/hostel/HostelFine';
import HostelClearanceCertificate from '@/pages/hostel/ClearanceCertificate';
import HostelReport from '@/pages/hostel/HostelReport';

export const hostelRoutes = (
  <React.Fragment>
    <Route path="hostel/setting" element={<HostelSetting />} />
    <Route path="hostel/room-type" element={<RoomType />} />
    <Route path="hostel/room-setting" element={<RoomSetting />} />
    <Route path="hostel/warden-setting" element={<WardenSetting />} />
    <Route path="hostel/add-student" element={<AddStudent />} />
    <Route path="hostel/fee-setting" element={<FeeSetting />} />
    <Route path="hostel/fee-payment" element={<FeePayment />} />
    <Route path="hostel/student-ledger" element={<HostelStudentLedger />} />
    <Route path="hostel/fee-report" element={<FeeReport />} />
    <Route path="hostel/damage" element={<HostelDamage />} />
    <Route path="hostel/fine" element={<HostelFine />} />
    <Route path="hostel/clearance-certificate" element={<HostelClearanceCertificate />} />
    <Route path="hostel/report" element={<HostelReport />} />
  </React.Fragment>
);
